import React from 'react';
import './index.less';

const UserMessage = ({ message, t = (term) => term }) => {
    const i18n = typeof window.global_i18n === "function" ? window.global_i18n: t;

    return (
        message && (
            <div className="message user">
                <div className="inner_row">
                    <span className="chat_name">{i18n('You')}</span>
                </div>
                <div className="message_content">
                    <span className="message_text">{message}</span>
                </div>
            </div>
        )
    );
};

export default UserMessage;
